import { useEffect, useRef, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useForm } from "react-hook-form";

//api
import { KBService } from "../../service/kb-service";

//components
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import DeleteKbFile from "./DeleteKbFile";
import ReactMarkdown from 'react-markdown';
import { Dialog } from "primereact/dialog";


const KnowledgeBaseDetail = ()=>{
    const {id}= useParams();
    const navigate = useNavigate()
    const [kbFile,setKbFile]= useState();
    const { register, handleSubmit,setValue} = useForm();
    // eslint-disable-next-line no-unused-vars
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null)
    const [markdownContent, setMarkdownContent] = useState('');
    const [previewVisible, setPreviewVisible] = useState(false);
    const [selectedFileForPreview, setSelectedFileForPreview] = useState(null);
    const [imageUrlForPreview, setImageUrlForPreview] = useState(null);
    const toast = useRef(null);

    const status = [
        {name: 'active'},
        {name: 'archived'}
    ]

    //chiamata GET
    useEffect(()=>{
        const fetchKBFile = ()=>{
            KBService.getKBFile(
                id,
                (data)=>{
                    setKbFile(data);
                    setValue('title', data.title);
                    setValue('description', data.description);
                    setValue('status', data.status);

                    if (data.file_name) {
                        setSelectedFile({ name: data.file_name });
                    }

                    setSelectedStatus(status.find(s => s.name === data.status) || null); 
                }
            )
        }
        fetchKBFile();
    },[id,setValue])

    //chiamata PUT
    const onSubmit = (data)=>{

        const payload = {
            title: data.title,
            description:data.description,
            status:data.selectedStatus
        }
    
        KBService.updateKbFile(
            id,
            payload,
            (response)=>{
                toast.current.show({ severity: 'success', summary: 'Modifica', detail: 'File modificato!' });
                navigate('/dashboard/kb')
            }
        )
    }

    //anteprima .md,.pdf,.txt,.jpeg,.jpg,.png
    const handlePreview = (file) => {
        if (file) {
          if (file.file_type === 'pdf') {
          KBService.downloadKBFile(
              file.id, 
              (blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file.file_name || 'preview.pdf');
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);
              },
              (error) => {
                console.error('Errore durante il download del PDF:', error);
                toast.current.show({ severity: 'error', summary: 'Errore', detail: 'Impossibile scaricare il PDF.' });
              }
            );
          } else if (file.file_type === 'txt' || file.file_type === 'text' || file.file_type === 'md')  {
           const token = localStorage.getItem('token');
            if (token) {
              KBService.fetchMarkdownContent(
                file.id, 
                token,
                setMarkdownContent
              );
              setSelectedFileForPreview(file);
              setPreviewVisible(true);
            } else {
              console.error('Token di autorizzazione non trovato.');
              toast.current.show({ severity: 'warn', summary: 'Avviso', detail: 'Token di autorizzazione non trovato. Impossibile visualizzare l\'anteprima.' });
            }
          } else if (['jpeg', 'jpg', 'png'].includes(file.file_type)) {
          KBService.downloadKBFile(
              file.id,
              (blob) => {
                const url = window.URL.createObjectURL(new Blob([blob], { type: `image/${file.file_type}` }));
                setImageUrlForPreview(url);
                setSelectedFileForPreview(file);
                setPreviewVisible(true);
              },
              (error) => {
                console.error('Errore durante il download dell\'immagine:', error);
                toast.current.show({ severity: 'error', summary: 'Errore', detail: 'Impossibile caricare l\'immagine per l\'anteprima.' });
              }
            );
        }else {
            console.log('Anteprima non disponibile per questo tipo di file. Verrà avviato il download se supportato.');
            toast.current.show({ severity: 'info', summary: 'Info', detail: 'Anteprima non disponibile per questo tipo di file. Se supportato, verrà avviato il download.' });
          }
        } else {
          console.log('File non trovato per l\'anteprima.');
          toast.current.show({ severity: 'warn', summary: 'Avviso', detail: 'File non trovato per l\'anteprima.' });
        }
    };
    
    const hidePreviewDialog = () => {
      setPreviewVisible(false);
      setMarkdownContent('');
      setSelectedFileForPreview(null);
    };
    

    

    return (
        <div className="template__Container">
            <h1>Gestione: {kbFile?.title}</h1> 
            <div style={{marginLeft:'2rem', display:'flex', alignItems:'center'}}>
            <h5>Nome file: {kbFile?.file_name}</h5></div>
            <Button
                    label="Visualizza Anteprima"
                    severity="info"
                    style={{ marginLeft: '2rem' }}
                    aria-label="Preview"
                    onClick={() => handlePreview(kbFile)}
                  />
            <form onSubmit={handleSubmit(onSubmit)} className="template__FormWrapper">
                <h3>Modifica Dati File</h3>
                <div className="p-field addAnalysisFile__InputWrapper">
                    <label htmlFor="name">Titolo</label>
                    <InputText id="name" {...register('title')}/>
                </div>
                <div className="p-field addAnalysisFile__InputWrapper" >
                    <label htmlFor="description">Descrizione</label>
                    <InputTextarea id="description" {...register('description')} rows={5} cols={30} />
                </div>
                <div  style={{margin:'1rem 0'}}>
                    <div className="card template__DropdownInput" style={{marginRight:'2.5rem'}}>
                        <label htmlFor="name">Stato</label>
                        <Dropdown value={selectedStatus} onChange={(e) =>  setSelectedStatus(e.value)} options={status} optionLabel="name" 
                            placeholder="Seleziona uno Status" className="w-full md:w-14rem" style={{margin:'0.5rem 0', width:'250px'}}/>
                    </div>
                </div>
                <div className="template__ButtonWrapper">
                    <div>
                      <Toast ref={toast} />
                      <Button label="Salva" type="submit"/>  
                    </div>
                    <DeleteKbFile kbFileId={id}/>
                </div>
                
            </form>
            {selectedFileForPreview && (
                <Dialog
                  header={`Anteprima ${selectedFileForPreview.file_name}`}
                  visible={previewVisible}
                  style={{ width: '80vw', height: '80vh' }}
                  onHide={hidePreviewDialog}
                  maximizable
                >
                  {['txt', 'text', 'md'].includes(selectedFileForPreview.file_type) ? (
                    <div
                      style={{
                        height: '100%',
                        overflowY: 'auto',
                        border: '1px solid #ccc',
                        padding: '10px',
                        backgroundColor: '#f9f9f9',
                      }}
                    >
                      <ReactMarkdown>{markdownContent}</ReactMarkdown>
                    </div>
                  ) : ['jpeg', 'jpg', 'png'].includes(selectedFileForPreview.file_type) && imageUrlForPreview ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <img 
                            src={imageUrlForPreview} 
                            alt={`Anteprima di ${selectedFileForPreview.file_name}`} 
                            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} 
                        />
                    </div>
                  ) : (
                    <p>
                      Anteprima non disponibile per questo tipo di file.
                      Controlla nella cartella Download se il download è stato avviato.
                    </p>
                  )}
                </Dialog>
              )}
        </div>
    )

}

export default KnowledgeBaseDetail